module.exports = __webpack_public_path__ + "static/media/dni.7504b689.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dni.png
// module id = 653
// module chunks = 0